import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {ReactComponent as WrapArrow} from '../../assets/wrap-arrow.svg';
// import WrapArrow from '../../assets/wrap-arrow.svg';
import { Button } from '../../components/Button';
import { setFilters } from '../../redux/orderSlice';
import OutsideClickHandler from 'react-outside-click-handler';
import { accessor } from '../../helpers';
import { Input } from '../../components/Input';

export const OrdersFilters = ({ titles }) => {
    const dispatch = useDispatch();
    const _titles = [...titles, {key: 'creator', label: 'Создатель заказа'}, {key: 'clearAmount', label: 'Чистая'}]
    const [isFilterWrapped, setWrapFilter] = useState(false);

    const closeFilterHandler = () => {
        if (!isFilterWrapped) return;
        setWrapFilter(false);
    }

    const Filter = ({ includeList, keyName, setFilters, enums }) => {
        const name = _titles.find((t) => t.key === keyName).label;
        const allChecked = enums.length === includeList.length;

        const switchAllFilterHandler = (evt) => {
            if (evt.target.checked) {
                setFilters(enums.map((e) => String(e._id)));
                return;
            }
            setFilters([String(enums[0]._id)]);
        };
        const switchFilterHandler = (evt) => {
            if (evt.target.checked) {
                setFilters([...includeList, evt.target.value]);
            } else {
                if (includeList.length > 1) {
                    setFilters(includeList.filter((str) => str !== evt.target.value));
                }
            }
        };
        const [search, setSearch] = useState('');
        const filteredEnums = enums.filter(e => e.name.toLowerCase().includes(search.toLowerCase()));
        
        return (
            <div className={`orders-filter dark-theme-bg0 ${keyName === 'worker' || keyName === 'creator' ? 'scroll-filter' : ''}`}>
                <div className="orders-filter__title">{name}</div>
                <Input placeholder="поиск" value={search} changeHandler={(e) => setSearch(e.target.value)} />
                <div className="orders-filter__option">
                    <input
                        id={`all_${name}`}
                        type="checkbox"
                        checked={allChecked}
                        onChange={switchAllFilterHandler}
                    />
                    <label htmlFor={`all_${name}`}>Все</label>
                </div>
                {filteredEnums.map((type) => (
                    <div className="orders-filter__option" key={type._id}>
                        <input
                            id={`${name}_${type._id}`}
                            type="checkbox"
                            value={String(type._id)}
                            checked={allChecked || includeList.some((s) => s === String(type._id))}
                            onChange={switchFilterHandler}
                        />
                        <label htmlFor={`${name}_${type._id}`}>{type.name}</label>
                    </div>
                ))}
            </div>
        );
    };

    const DateFilter = ({keyName, interval, setFilters }) => {

        const name = _titles.find((t) => t.key === keyName).label;
        const [localValue, setLocalValue] = useState(interval)

        return (
            <div className='orders-filter orders-filter-date'>
                <div className="orders-filter__title">{name}</div>
                <div className="orders-filter__option">
                    <label>с</label>
                    <input type="date" value={localValue.min} 
                        onBlur={() => setFilters(localValue)} 
                        onChange={(e) => setLocalValue({...interval, min: e.target.value})} 
                    />
                </div>
                <div className="orders-filter__option">
                    <label>до</label>
                    <input type="date" value={localValue.max} 
                        onBlur={() => setFilters(localValue)}
                        onChange={(e) => setLocalValue({...interval, max: e.target.value})} 
                    />
                </div>
            </div>
        );
    };

    const ClearAmountFilter = ({keyName, interval, setFilters }) => {
        const name = _titles.find((t) => t.key === keyName).label;
        const [localValue, setLocalValue] = useState(interval)

        return (
            <div className='orders-filter orders-filter-date'>
                <div className="orders-filter__title">{name}</div>
                <div className="orders-filter__option">
                    <label>от</label>
                    <input type="number" value={localValue.min} 
                        onBlur={() => setFilters(localValue)} 
                        onChange={(e) => setLocalValue({...interval, min: e.target.value})} 
                    />
                </div>
                <div className="orders-filter__option">
                    <label>до</label>
                    <input type="number" value={localValue.max} 
                        onBlur={() => setFilters(localValue)}
                        onChange={(e) => setLocalValue({...interval, max: e.target.value})} 
                    />
                </div>
            </div>
        );
    };

    const workers = ['null', ...useSelector((state) => state.settings.orderUsers)];
    const availableWorkers = [{_id: 'null', fullname: 'Без мастера', deleted: false, profiles: [1]}, ...useSelector((state) => state.users.list)]
        .map((u) => ({ _id: u._id, name: u.fullname, deleted: u.deleted, profiles: u.profiles }))
        .filter((u) => workers.some((w) => w === u._id && !u.deleted && u.profiles.length));

    const availableCreators = useSelector((state) => state.users.list)
        .map((u, i) => ({ _id: u._id, name: u.fullname, deleted: u.deleted, hasOrdersAccess: !u.deleted && accessor.orders(u) }))
        .filter((u) => u.hasOrdersAccess);

    const filters = useSelector((state) => state.orders.filter);

    const defaultFilters = filters
        .map((f) => (f.key === 'worker' ? { ...f, list: availableWorkers } : f.key === 'creator' ? { ...f, list: availableCreators } : f))
        .filter((f) => !f.type);
        
    const dateFilters = filters.filter((f) => f.type === 'date');
    const caFilter = filters.find((f) => f.type === 'number');

    const createFilterHandler = (key) => {
        return (selected) => {
            const newFilters = filters.map((f) => (f.key === key ? { ...f, selected } : f));
            localStorage.setItem('orderFilter', JSON.stringify(newFilters));
            dispatch(setFilters(newFilters));
        };
    };

    const createDateFilterHandler = (key) => {
        return (interval) => {
            const newFilters = filters.map((f) => (f.key === key ? { ...f, interval } : f));
            localStorage.setItem('orderFilter', JSON.stringify(newFilters));
            dispatch(setFilters(newFilters));
        };
    };

    const resetFiltersHandler = () => {
        localStorage.removeItem('orderFilter');
        dispatch(setFilters(filters.map(f => {
            if (!Object.keys(f).length) return f;
            if (!f.type && f.key !== 'worker') {//@ts-ignore //Только для дефолтных фильтров (не с датой)
                return {...f, selected: f.list.map((e) => String(e._id))}
            } else if (f.key === 'worker') {//@ts-ignore
                return {...f, selected: f.list}
            } else {
                return {...f, interval: {min: '', max: ''}}
            }
        })));
    }

    return (
        <OutsideClickHandler onOutsideClick={closeFilterHandler}>
            <div className="orders-manager__filters orders-filters dark-theme-bg0">
            <div className="orders-filters__title" onClick={() => setWrapFilter((prev) => !prev)}>
                Фильтры
                <div className={`${isFilterWrapped ? 'opened' : ''}`}>
                    <WrapArrow />
                </div>
            </div>
            <div className="orders-filters__body-container">
                <div className={`orders-filters__body dark-theme-bg0 ${isFilterWrapped ? 'opened' : ''}`}>
                    <div className="orders-filters__options">
                        {defaultFilters.map((f) =>
                            f.key ? (
                                <Filter
                                    includeList={f.selected}
                                    keyName={f.key}
                                    key={f.key}
                                    enums={f.list}
                                    setFilters={createFilterHandler(f.key)}
                                />
                            ) : null,
                        )}
                        {dateFilters.map((f) => 
                            <DateFilter key={f.key} interval={f.interval} keyName={f.key} setFilters={createDateFilterHandler(f.key)} />)
                        }
                        {<ClearAmountFilter key={caFilter.key} interval={caFilter.interval} keyName={caFilter.key} setFilters={createDateFilterHandler(caFilter.key)} />}

                    </div>
                    <div className="orders-filters__footer">
                        <Button text="Сброс" onClick={resetFiltersHandler} />
                    </div>
                </div>
            </div>
        </div>
        </OutsideClickHandler>
    );
};
